import Vue from 'vue'
import _ from 'underscore'

export default {

    namespaced: true,

    state: {

        data: {}

    },

    getters: {

        all: function(state) {

            return state.data

        },

        start: function(state) {

            return state.data.start || 0

        },

        end: function(state) {

            return state.data.end || 0

        },

        overview: function(state) {

            return state.data.overview || []

        },

        mostplays: function(state) {

            return state.data.mostplays || []

        },

        newcomers: function(state) {

            return state.data.newcomers || []

        },

        activity: function(state) {

            return state.data.activity || []

        },

        plays: function(state) {

            return state.data.plays || []

        },

        weights: function(state) {

            return state.data.weights || []

        },

        counts: function(state) {

            return state.data.counts || []

        },

        groups: function(state) {

            return state.data.groups || []

        },

        games: function(state) {

            return state.data.games || []

        },

        streaks: function(state) {

            return state.data.streaks || []

        },

        hindex: function(state) {

            return state.data.hindex || []

        },

        duration: function(state) {

            return state.data.duration || []

        },

        specialised: function(state) {

            return state.data.specialised || []

        },

        mostgames: function(state) {

            return state.data.mostgames || []

        },

        wins: function(state) {

            return state.data.wins || []

        },

        directory: function(state) {

            return state.data.directory || []

        }

    },

    mutations: {

        reset: function(state) {

            state.data = {}

        },

        set: function(state, data) {

            _.each(data, function(value, key) {

                Vue.set(state.data, key, value)

            })

        }

    },

    actions: {}

}